<template>
  <div class="main row">
    <div class="col-md-12">
      <KTCodePreview v-bind:title="'Khai báo ngân sách 12 tháng'">
        <template v-slot:preview>
          <BudgetLineDeclareForm
            :mode="'create'"
            :disabled="isSaving"
            :showBack="true"
            :submitText="'Khai báo'"
            @back="goBack"
            @submit="submitCreate"
          />
        </template>
      </KTCodePreview>
    </div>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import { makeToastSuccess, handleError } from '@/utils/common';
import BudgetLineDeclareForm from './components/BudgetLineDeclareForm.vue';

export default {
  components: {
    KTCodePreview,
    BudgetLineDeclareForm,
  },
  data() {
    return {
      isSaving: false,
    };
  },
  created() {
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Kế toán', route: '#' },
      { title: 'Ngân sách', route: '/budget/budget-lines' },
      { title: 'Khai báo' },
    ]);
  },
  methods: {
    makeToastSuccess,
    submitCreate(payload) {
      this.isSaving = true;
      ApiService.post('v2/budget-lines/declare', payload)
        .then(({ data }) => {
          this.makeToastSuccess(data.message);
          this.$router.push({ name: 'list-budget-lines' });
        })
        .catch((err) => handleError(err))
        .finally(() => {
          this.isSaving = false;
        });
    },
    goBack() {
      this.$router.push({ name: 'list-budget-lines' });
    },
  },
};
</script>

<style scoped>
.declare-year-picker {
  cursor: pointer;
}
</style>
